import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FontDownload } from '@styled-icons/material/FontDownload';
import { FormatColorText } from '@styled-icons/material/FormatColorText';
import { Link } from '@styled-icons/material/Link';
import { focusEditor, LinkToolbarButton, MARK_BG_COLOR, MARK_COLOR, triggerFloatingLinkInsert, usePlateEditorRef, } from '@udecode/plate';
import AlignToolbarButtons from './align/AlignToolbarButtons';
import BasicElementToolbarButtons from './basic-elements/BasicElementToolbarButtons';
import BasicMarkToolbarButtons from './basic-marks/BasicMarkToolbarButtons';
import IndentToolbarButtons from './indent/IndentToolbarButtons';
import ListToolbarButtons from './list/ListToolbarButtons';
import FontSizeToolbarButtons from './font/FontSizeToolbarButtons';
import FontFamilyToolbarButtons from './font/FontFamilyToolbarButtons';
import ColorPickerToolbar from './color/ColorPickerToolbar';
const ToolbarButtons = () => {
    const editor = usePlateEditorRef();
    const handleInsertLinkClick = () => {
        if (!editor)
            return;
        if (!editor.selection) {
            focusEditor(editor, { offset: 0, path: [0, 0] });
        }
        else {
            focusEditor(editor, editor.selection);
        }
        triggerFloatingLinkInsert(editor, { focused: true });
    };
    return (_jsxs(_Fragment, { children: [_jsx(BasicElementToolbarButtons, {}), _jsx(FontSizeToolbarButtons, {}), _jsx(FontFamilyToolbarButtons, {}), _jsx(ListToolbarButtons, {}), _jsx(IndentToolbarButtons, {}), _jsx(BasicMarkToolbarButtons, {}), _jsx(ColorPickerToolbar, { pluginKey: MARK_COLOR, icon: _jsx(FormatColorText, {}) }), _jsx(ColorPickerToolbar, { pluginKey: MARK_BG_COLOR, icon: _jsx(FontDownload, {}) }), _jsx(AlignToolbarButtons, {}), _jsx(LinkToolbarButton, { onClick: handleInsertLinkClick, icon: _jsx(Link, {}) })] }));
};
export default ToolbarButtons;
//# sourceMappingURL=ToolbarButtons.js.map